import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { clearDatahandling } from "../../../utils/clearDataHandling";
import BookingList from "../MyBookings/BookingList";
import { getServiceNonKeyApi } from "../../../services/api/settings.api";
import PendigOrdersList from "../MyOrders/PendingOrders/PendigOrdersList";
import { getProfileView } from "../../../redux/reducers/authSlice";

const Dashboard = () => {
  const { user, myprofile } = useSelector((state) => state.auth);
  const { myOrdersList } = useSelector((state) => state.orders)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const gotoPostal = (serviceType) => {

    navigate('/formpostal', { state: { serviceType: serviceType } })


  }
  useEffect(() => {
    clearDatahandling(dispatch)
  }, [])

  const gettPriceAPi = async () => {
    const value = await getServiceNonKeyApi();
    if (value.serverResponse.code === 200) {
      localStorage.setItem('priceDetails', JSON.stringify(value.result.list?.find(item => item.type === 'price').priceDetails))
    }
  };

  useEffect(() => {
    gettPriceAPi()
    if (user) {
      dispatch(getProfileView())
    }
  }, [])

  return (
    <>
      <div className="Dashboard-page-main">
        <div className="Dashboard-page-wrap">
          <div className="db-sec">
            <h1>Welcome back {user?.name},</h1>
            {/* After client's confirmation we will open this */}
            {/* <h4>Your Current Loyalty Ponit is {myprofile?.customer?.loyalityPoint}.</h4> */}
            <div className="row">
              <div className="col-lg-6">
                <div
                  className="general-cleaning-sec pink-bg cursor-pointer"

                >
                  <div className="general-cleaning-sec-row text-center position-relative" onClick={() => gotoPostal("order-booking")}>
                    {/* <div className="general-cleaning-content" onClick={() => gotoPostal("order-booking")}>
                      <h4> General / Regular Cleaning</h4>

                      <NavLink to="/">Book Now</NavLink>
                    </div> */}
                    <div className="general-img1">
                      <img src="/assets/images/GenForm-Booknow.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div
                  className="general-cleaning-sec green-bg cursor-pointer"
                  onClick={() => gotoPostal("professional")}
                >
                  <div className="general-cleaning-sec-row text-center position-relative">
                    {/* <div className="general-cleaning-content">
                      <h4>Profesional Cleaning</h4>

                      <NavLink to="/">Book Now</NavLink>
                    </div> */}
                    <div className="general-img1">
                      <img src="/assets/images/GenForm-Booknow2.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="renew-sec-wrap">
              <div className="renew-heading">
                <h2>Regular cleaning schedule is ending soon. </h2>
                <p>Renew now to prevent distruption to your home cleaning.</p>
              </div>
              <div className="renew-btn">
                <NavLink to="/">1-Click Renew</NavLink>
              </div>
            </div> */}

            <div>
              <div className="upcoming-sec">
                <h2>{(myOrdersList && myOrdersList?.length > 0) ? 'Pending Orders' : ''}</h2>
              </div>
              <PendigOrdersList />

            </div>

            <div>
              <div className="upcoming-sec">
                <h2>Upcoming Bookings</h2>
              </div>
              <BookingList />

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
